export const environment = {
  production: true,
  defaultUrlServer: 'https://api-cvx.sistemis.ro/cpp/',
  saasServer: 'https://api-cvx.sistemis.ro/saas/',
  authServer: 'https://api-cvx.sistemis.ro/auth/',
  deployId: '33f479a3-f549-473a-94bd-74dad24608e8',
  notifyServer: 'wss://ws-cvx.sistemis.ro/notify'
};
